import { render } from "./ParticipantPageHeader.vue?vue&type=template&id=3d819eac&scoped=true&ts=true"
import script from "./ParticipantPageHeader.vue?vue&type=script&lang=ts"
export * from "./ParticipantPageHeader.vue?vue&type=script&lang=ts"

import "./ParticipantPageHeader.vue?vue&type=style&index=0&id=3d819eac&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d819eac"]])

export default __exports__